import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/registro/importer/registroImporterActions';

export default importerReducers(actions);
